const CONSTANTS = {
  WELCOME_MSG: 'welcome_msg',
  COMPONENT_LIST_MSG: 'component_list_msg',
  DEFAULT_MSG: 'default_msg',
  PROFILE_MSG: 'profile_msg',
  SXP_TITLE: 'Welcome to TSF React base project',
  SXP_SUBTITLE: 'Service eXperience Platform',
  SXP_DEFAULT_MSG: 'Hi, Welcome To React Template Project',
  COULDNT_UPLOAD_DOC: 'Could not upload Document',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  SELECT_START_END_DATE: 'Select start date and end date',

  SETTINGS: 'settings',
  PROFILE: 'profile',
  LOGOUT: 'logout',
  THEME: 'theme',
  VERSION_ID: 'WORKING',

  BUSINESS_USER: 'business-user',
  USER_EMAIL: 'user-email',
  FIRST_NAME: 'first-name',
  LAST_NAME: 'last-name',
  USER_ID: 'user-id',
  REACT_TOKEN: 'react-token',
  USER_TYPE: 'user-type',
  COUNTRY: 'country',
  I18NEXTLNG: 'i18nextLng',

  TOKEN_MIN_VALIDITY: 50,
}

export const AUTH_SERVER_URL = process.env?.REACT_APP_KEYCLOAK_URL || ''
export const CLIENT_ID = process.env?.REACT_APP_KEYCLOAK_CLIENT_ID || ''
export const REALM = process.env?.REACT_APP_KEYCLOAK_REALM || ''

export default CONSTANTS

export const DIALOG_CATEGORIES = {
  PolicyExplanation: 'policyExplanation',
  PhysicalAssessmentLabTests: 'physicalAssessmentLabTests',
}

export const FIELD_TYPES = {
  SELECT: 'select',
  TEXT: 'text',
}

export const COMPARISON_FIELDS = {
  DOB: 'dob',
  AGE: 'age',
  HEIGHT: 'height',
  WEIGHT: 'weight',
}

export const USER_DIALOG_MODES = {
  CREATE: 'Create',
  UPDATE: 'Update',
}

export const FULLSCREEN_TOGGGLE_TEXT = {
  FULL_SCREEN: 'Best viewed in fullscreen',
  EXIT_FULL_SCREEN: 'Exit Full Screen',
}

export const USER_TABS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ALL: 'all',
}

export const USER_STATUS = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
]

export const USER_GENDER = [
  {
    label: 'Male',
    value: 'Male',
  },
  {
    label: 'Female',
    value: 'Female',
  },
]

export const NOTIFICATION_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
}

export const CARD_LAYOUT_OPTIONS = {
  GRID: 'grid',
  LIST: 'list',
}

export const PAYMENT_OPTIONS = {
  WHATSAPP: 'WhatsApp',
  SMS: 'SMS',
  GENERATEQR: 'Generate QR',
}
